import * as Sentry from "@sentry/react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ProtectedShell } from "@/components/AppShell/ProtectedShell";
import { IndexRedirect } from "@/pages/IndexRedirect";
import { SignInSplitPage } from "@/pages/SignInPage/SignInSplitPage";
import { SignInCenteredPage } from "@/pages/SignInPage/SignInCenteredPage";
import { ForgotPasswordPage } from "@/pages/SignInPage/ForgotPassword/ForgotPasswordPage";
import { SignInSsoCallback } from "@/pages/SignInPage/SignInSsoCallback";
import { CreateFlavorPage } from "@/pages/CreateFlavorPage/CreateFlavorPage";
import { GeneratingPage } from "@/pages/GeneratingPage/GeneratingPage";
import { WorkbenchPage } from "@/pages/WorkbenchPage/WorkbenchPage";
import { PrintFlaskPage } from "@/pages/PrintFlaskPage/PrintFlaskPage";
import { InstrumentsPage } from "@/pages/InstrumentsPage/InstrumentsPage";
import { SubstanceLibraryPage } from "@/pages/SubstanceLibraryPage/SubstanceLibraryPage";
import { DevShowcase } from "@/pages/DevShowcase/DevShowcase";
import { DevPlots } from "@/pages/DevPlots/DevPlots";

export default function App() {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error }) => (
        <div style={{ padding: 24, fontFamily: "monospace" }}>
          <h1>Something went wrong.</h1>
          <p>The error has been reported. Please refresh.</p>
          {import.meta.env.DEV ? <pre>{String(error)}</pre> : null}
        </div>
      )}
    >
      <Routes>
      {/* Index — redirect-only, no UI. Signed-in → /flavors/new, else → /sign-in. */}
      <Route path="/" element={<IndexRedirect />} />
      {/* /sign-in defaults to the split layout; both deep-links are first-class. */}
      <Route path="/sign-in" element={<Navigate to="/sign-in/split" replace />} />
      <Route path="/sign-in/split" element={<SignInSplitPage />} />
      <Route path="/sign-in/centered" element={<SignInCenteredPage />} />
      <Route path="/sign-in/forgot-password" element={<ForgotPasswordPage />} />
      {/* SSO return URL — runs Clerk's handleRedirectCallback regardless of
          signed-in state since the callback finalizes the session. */}
      <Route path="/sign-in/sso-callback" element={<SignInSsoCallback />} />
      {/* Protected app — sidebar + Settings popover wrap every child route. */}
      <Route element={<ProtectedShell />}>
        <Route path="/flavors/new" element={<CreateFlavorPage />} />
        <Route
          path="/flavors/new/generating"
          element={<GeneratingPage />}
        />
        <Route path="/flavors/:id" element={<WorkbenchPage />} />
        <Route path="/ingredients" element={<SubstanceLibraryPage />} />
        <Route path="/instruments" element={<InstrumentsPage />} />
        <Route path="/print/flavor/:flavorId/formulas/:formulaId" element={<PrintFlaskPage />} />
      </Route>
      {/* Dev-only visual smoke route — auth-independent. */}
      <Route path="/dev/showcase" element={<DevShowcase />} />
      <Route path="/dev/plots" element={<DevPlots />} />
      <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Sentry.ErrorBoundary>
  );
}
